import { ChangePasswordForm } from '@r/components/auth/change-password-form.tsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/card.tsx';
import { useContext } from 'react';
import { WorkspaceConfigContext } from '@r/context/workspace-config-context.ts';
import defaultLogo from '@r/assets/images/fiddy/logo.svg';
import { useTranslation } from 'react-i18next';

export const ChangePassword = () => {
  const workspaceConfigContext = useContext(WorkspaceConfigContext);
  const { t } = useTranslation();

  return (
    <div className="container flex flex-col pt-8 grow">
      <div className="flex w-full max-w-[100%] flex-grow items-center sm:w-[32rem]">
        <Card className="w-[32rem] rounded-[30px] p-16">
          <CardHeader className="p-0 text-center">
            <img
              src={workspaceConfigContext?.groupedConfigs?.media?.logo || defaultLogo}
              className="object-contain object-center px-6 m-auto w-full xs:w-10/12 sm:w-8/12 md:w-7/12"
              alt="logo"
            />

            <CardTitle className="break-words text-center font-author-complete font-regular text-[2rem] text-foreground leading-[3rem] sm:text-[2.50rem]">
              {t('auth.changepassword.title')}
            </CardTitle>

            <CardDescription className="text-sm font-light text-center text-muted-foreground">
              {t('auth.changepassword.description')}
            </CardDescription>
          </CardHeader>

          <CardContent className="p-0 pt-7">
            <ChangePasswordForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ChangePassword;
